import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-green-jade',
  templateUrl: './green-jade.component.html',
  styleUrls: ['./green-jade.component.scss']
})
export class GreenJadeComponent implements OnInit {

  constructor(
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }

  @Input() src: SafeUrl;

  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `text/javascript`;
    script.text = this.getScript();
    this._renderer2.appendChild(this._document.body, script);
  }

  getScript() {
    return `const CONTAINER_ID = 'iframe-container';
            const LOBBY_IFRAME_ID = 'lobby-iframe';
            const CLASS_GAME_IFRAME = 'game-iframe';
            const CLASS_DEFAULT_IFRAME = 'default-iframe';
            let iframeSettings = {
            newHeight: '500px',
            };
    
    window.addEventListener("message", handleHeight);
              function handleHeight(e) {
                const data = e.data;
                if (data.eventName === "HEIGHT_CHANGED") {
                const payload = data.payload;
                if (iframeSettings.newHeight !== payload.newHeight) {
                iframeSettings.newHeight = payload.newHeight;
                document.getElementById(LOBBY_IFRAME_ID).style.height =
                iframeSettings.newHeight;
                if (payload.isRelativeHeight) {
                document.getElementById(CONTAINER_ID).classList.add
                (CLASS_GAME_IFRAME)
                document.getElementById(CONTAINER_ID).classList.remove
                (CLASS_DEFAULT_IFRAME)
                } else {
                document.getElementById(CONTAINER_ID).classList.add
                (CLASS_DEFAULT_IFRAME)
                document.getElementById(CONTAINER_ID).classList.remove
                (CLASS_GAME_IFRAME)
              }
              }
              };`
  }

}
